import type { ExcJpmamV1JpmamJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const JPMAM_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/jpm/job');

export const getJpmamJobPath: EntityPathBuilder<ExcJpmamV1JpmamJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return JPMAM_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jpmamJobId) {
        return undefined;
      }

      return getResolvedPath(`${JPMAM_JOB_BASE_PATH}/$jobId`, { jobId: context.keys.jpmamJobId, ...context.keys });
    }
  }
};

export function getJpmamJobDetailPath(jpmamJobId: string | undefined) {
  if (!jpmamJobId) {
    return undefined;
  }

  return getJpmamJobPath({ kind: 'detail', keys: { jpmamJobId } });
}
